import { ChampFormOM } from "./ChampForm";


export class LineFormOM {

  public Ident: string;

  public NbChamp: number;

  public ListChamp: Array<ChampFormOM>;

  // Pour savoir si c'est une ligne "CLIENT" ou "CONTACT"
  public TypeLigne: string;

}
